/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassPlanningChecklistItemViewModel } from "../types/ClassPlanningChecklistItemViewModel.ts";

export const classPlanningChecklistItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  classPlanningCheckListId: z.optional(z.number().int()),
  description: z.string().nullish(),
  isDone: z.optional(z.boolean()),
  orderIndex: z.optional(z.number().int()),
  value: z.number().nullish(),
  observation: z.string().nullish(),
}) as unknown as ToZod<ClassPlanningChecklistItemViewModel>;
